import { CurrencyIcon } from '@components'
import { PasswordTermsCheckIcon } from '@icons'
import cn from 'classnames'
import type { AccountBalanceResponse } from 'mmfintech-backend-api/types'
import { formatMoney, tr } from 'mmfintech-commons'
import './SelectedAccount.scss'

interface Props {
  account: AccountBalanceResponse
  isSelected: boolean
  error?: string
  setAccount: (account: AccountBalanceResponse) => void
}

function SelectedAccount({ account, isSelected, setAccount, error }: Props) {
  const { balance, currencyCode, name } = account || {}
  return (
    <div
      className={cn('account-button', {
        'no-shadow': true,
        // static: true,
        error: error?.length,
        'no-border': false,
        'is-selected': isSelected
      })}
      onClick={() => setAccount(account)}
    >
      <span className='account-info'>
        <span className='icon'>
          <CurrencyIcon currency={currencyCode} size='26px' />
        </span>
        <span className='content'>
          <span className='balance'>
            <b>{tr('FRONTEND.COMPONENTS.SELECT_ACCOUNT.BALANCE_LABEL', 'Balance')}:</b>{' '}
            {formatMoney(balance, currencyCode)}
          </span>
          <span>{name}</span>
        </span>
      </span>

      {isSelected && <PasswordTermsCheckIcon />}
      {/* {!staticDisplay && <span className='chevron'>{visible ? <ChevronUp /> : <ChevronDown />}</span>} */}
    </div>
  )
}

export default SelectedAccount
